var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review"},[_c('div',{staticClass:"review_top"},[_c('van-cell',{staticClass:"large50",attrs:{"title":_vm.msgDetail.title,"size":"large","center":"","icon":_vm.avatar}}),_c('div',{staticClass:"message_text",domProps:{"innerHTML":_vm._s( _vm.msgDetail.content )}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }